import React, { ReactElement, ReactNode, useMemo } from "react";
import * as AlertDialog from "@radix-ui/react-alert-dialog";
import styles from "./alert.module.scss";
import classNames from "classnames";

export const Alert = (props: Props): ReactElement => {
  const {
    triggerNode,
    title,
    description,
    cancelNode,
    actionNode,
    contentClass,
    overlayClass,
    titleClass,
    descriptionClass,
    orientation,
    iconNode,
    onAction,
    onCancel,
    open,
    onOpenChange,
  } = props;

  return (
    <AlertDialog.Root open={open} onOpenChange={onOpenChange}>
      <AlertDialog.Trigger asChild>{triggerNode}</AlertDialog.Trigger>
      <AlertDialog.Portal>
        <AlertDialog.Overlay
          className={classNames(styles["overlay"], overlayClass)}
        />
        <AlertDialog.Content
          className={classNames(
            styles["contentWrapper"],
            [styles[orientation]],
            { [styles["centered"]]: props.centered },
            contentClass,
          )}
        >
          {iconNode && <div className={styles["icon"]}>{iconNode}</div>}
          <div className={classNames(styles["default"])}>
            <AlertDialog.Title
              className={classNames(styles["title"], titleClass)}
              data-testid="alert-title"
            >
              {title}
            </AlertDialog.Title>
            <AlertDialog.Description
              className={classNames(styles["desc"], descriptionClass)}
              data-testid="alert-desc"
            >
              {description}
            </AlertDialog.Description>
            <div
              className={classNames(styles["actionWrapper"], [
                styles[orientation],
              ])}
            >
              {cancelNode && (
                <AlertDialog.Cancel asChild onClick={onCancel}>
                  {cancelNode}
                </AlertDialog.Cancel>
              )}
              {actionNode && (
                <AlertDialog.Action asChild onClick={onAction}>
                  {actionNode}
                </AlertDialog.Action>
              )}
            </div>
          </div>
        </AlertDialog.Content>
      </AlertDialog.Portal>
    </AlertDialog.Root>
  );
};

interface Props {
  triggerNode?: ReactNode;
  title?: string;
  description?: string;
  cancelNode?: ReactNode;
  actionNode?: ReactNode;
  contentClass?: string;
  overlayClass?: string;
  titleClass?: string;
  descriptionClass?: string;
  orientation: "vertical" | "horizontal";
  centered?: boolean;
  iconNode?: ReactNode;
  onAction?: () => void;
  onCancel?: () => void;
  open?: boolean;
  onOpenChange?: AlertDialog.AlertDialogProps["onOpenChange"];
}
